// extracted by mini-css-extract-plugin
module.exports = {"AdformInview__adform":"lx_a pz_je","AdformInview__adform--expanded":"lx_b"};